// extracted by mini-css-extract-plugin
module.exports = {"circlBtnLg":"buttons_circlBtnLg__fPwyF","circlBtnSm":"buttons_circlBtnSm__1mzVy","container":"buttons_container__1czqh"};